<div class="nav-toolbar p-5 bg-white">
    <app-logo></app-logo>

    <button class="home-button" mat-stroked-button color="primary" appGoHome aria-label="Home Page">
        <span class="sr-only"> Home Page </span>
        <mat-icon svgIcon="home"></mat-icon>
    </button>

    <button
        class="bell-button"
        mat-stroked-button
        color="primary"
        (click)="changeSoundStatus()"
        matTooltip="Bidding Bell control"
        [matTooltipPosition]="'right'"
        aria-label="Bidding Bell control"
    >
        <mat-icon [svgIcon]="isSoundDisabled ? 'notifications-off' : 'notifications-active'"></mat-icon>
    </button>

    @if (canViewBidderDetails() && isSaleyardAuction()) {
        <button
            class="truck-button truck-btn"
            mat-stroked-button
            color="primary"
            (click)="openTransportDrawer()"
            aria-label="Transport & Purchase Details"
        >
            <mat-icon>local_shipping</mat-icon>
        </button>
    }
</div>
